import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import {
  footerTaxoEmailSignUpSelector,
  storeIdentifierNameSelector,
  footerClientLoadingSelector,
} from 'store/selectors';
import { useAppSelector } from 'store/store';
import { StoreIdentifierName } from 'types';
import FooterEmailSignUp from './FooterEmailSignUp';

const FooterEmailSignUpContainer = () => {
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const emailSignUp = useAppSelector(footerTaxoEmailSignUpSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!emailSignUp && isLoading) {
    return null;
  }

  if (!emailSignUp) {
    throw new Error(
      'Homr did not return any "footerEmailSignup" content. Make sure the correct data is being returned!',
    );
  }
  return (
    <ErrorBoundaryWithLogger componentId="FooterPL-FooterEmailSignUp">
      <FooterEmailSignUp
        footerEmailSignUpData={emailSignUp}
        storeIdentifierName={storeIdentifierName as StoreIdentifierName}
      />
    </ErrorBoundaryWithLogger>
  );
};

export default FooterEmailSignUpContainer;
